import Message from './Message.vue';

export default Message;



// WEBPACK FOOTER //
// ./src/pages/profile/components/info/components/block/components/resultform/components/message/index.ts